export type EditorMode = 'edit' | 'design';

export const EDITOR_MODE_STORAGE_KEY = 'e-credits.editor-mode';

export function getStoredEditorMode(): EditorMode {
  try {
    const storedMode = window.localStorage.getItem(EDITOR_MODE_STORAGE_KEY);
    return storedMode === 'design' || storedMode === 'edit' ? storedMode : 'edit';
  } catch {
    return 'edit';
  }
}

export function storeEditorMode(mode: EditorMode): void {
  try {
    window.localStorage.setItem(EDITOR_MODE_STORAGE_KEY, mode);
  } catch {
    // Storage can be unavailable in private browsing or restricted environments.
  }
}

export const EDIT_PANE_MIN_HEIGHT = 260;
export const EDIT_DIVIDER_HEIGHT = 12;
// Keep this as the single tuning point for the default editor split.
// It applies to the editor preview/data-grid split in both project modes.
export const DEFAULT_EDIT_PREVIEW_PANE_RATIO = 0.80;
export const EDIT_GRID_MIN_WIDTH = 403;
export const EDIT_DIVIDER_WIDTH = 12;
// Keep the preview readable before allowing the two editor panes to sit side by side.
export const EDIT_HORIZONTAL_PREVIEW_MIN_WIDTH = 600;
export const EDIT_HORIZONTAL_LAYOUT_MIN_WIDTH = (
  EDIT_HORIZONTAL_PREVIEW_MIN_WIDTH + EDIT_DIVIDER_WIDTH + EDIT_GRID_MIN_WIDTH
);

export function clampEditPreviewPaneHeight(
  requestedHeight: number | null,
  workspaceHeight: number
): number {
  const availableHeight = Math.max(0, workspaceHeight - EDIT_DIVIDER_HEIGHT);
  const maximumHeight = Math.max(EDIT_PANE_MIN_HEIGHT, availableHeight - EDIT_PANE_MIN_HEIGHT);
  const defaultHeight = Math.round(availableHeight * DEFAULT_EDIT_PREVIEW_PANE_RATIO);
  const nextHeight = requestedHeight ?? defaultHeight;

  return Math.max(EDIT_PANE_MIN_HEIGHT, Math.min(nextHeight, maximumHeight));
}

export function clampEditPreviewPaneWidth(
  requestedWidth: number | null,
  workspaceWidth: number
): number {
  const availableWidth = Math.max(0, workspaceWidth - EDIT_DIVIDER_WIDTH);
  const maximumWidth = Math.max(EDIT_HORIZONTAL_PREVIEW_MIN_WIDTH, availableWidth - EDIT_GRID_MIN_WIDTH);
  const defaultWidth = Math.round(availableWidth * DEFAULT_EDIT_PREVIEW_PANE_RATIO);
  const nextWidth = requestedWidth ?? defaultWidth;

  return Math.max(EDIT_HORIZONTAL_PREVIEW_MIN_WIDTH, Math.min(nextWidth, maximumWidth));
}
